<template>
   <div class="hotel-filters-container">#hotelfilterscontainer</div>
</template>

<script>
export default {
   name: "HotelFilters",
   created() {
   },
};
</script>

<style></style>
